import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

const Icon = ({ children }: { children: ReactNode }) => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    {children}
  </svg>
);

const STEPS: {
  id: string;
  titleKey: string;
  hintKey: string;
  icon: ReactNode;
}[] = [
  {
    id: "create",
    titleKey: "home.stepCreate",
    hintKey: "home.stepCreateHint",
    icon: (
      <Icon>
        <rect x="3.5" y="5" width="17" height="15.5" rx="2" />
        <path d="M3.5 9.5h17M8 3.5v3M16 3.5v3M12 13v5M9.5 15.5h5" />
      </Icon>
    ),
  },
  {
    id: "share",
    titleKey: "home.stepShare",
    hintKey: "home.stepShareHint",
    icon: (
      <Icon>
        <circle cx="6" cy="12" r="2.2" />
        <circle cx="17" cy="6.5" r="2.2" />
        <circle cx="17" cy="17.5" r="2.2" />
        <path d="M8 11.1 14.8 7.6M8 12.9l6.8 3.5" />
      </Icon>
    ),
  },
  {
    id: "join",
    titleKey: "home.stepJoin",
    hintKey: "home.stepJoinHint",
    icon: (
      <Icon>
        <circle cx="9" cy="8" r="2.6" />
        <path d="M3.8 19.2c.4-2.8 2.6-4.4 5.2-4.4s4.8 1.6 5.2 4.4" />
        <path d="M17 10.5v6M14 13.5h6" />
      </Icon>
    ),
  },
];

export const HowItWorks = () => {
  const { t } = useTranslation();

  return (
    <ol className="pp-steps">
      {STEPS.map((step) => (
        <li key={step.id}>
          <span className="pp-steps-icon">{step.icon}</span>
          <span>
            <strong>{t(step.titleKey)}</strong>
            <span className="pp-muted">{t(step.hintKey)}</span>
          </span>
        </li>
      ))}
    </ol>
  );
};
